"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PieChart = void 0;
var react_1 = __importStar(require("react"));
var recharts_1 = require("recharts");
var _EXPORTS_1 = require("../../../utils/_EXPORTS");
var getTotalCount_1 = require("../../../utils/getTotalCount");
var chartColors = [
    "#5C80FF",
    "#FFA800",
    "#00BC8F",
    "#FF51CE",
    "rgb(173, 89, 108)",
    "rgb(114, 190, 244)",
    "rgb(255, 178, 122)",
    "rgb(14, 126, 161)",
    "rgb(60, 169, 116)",
    "rgb(254, 187, 178)",
    "rgb(204, 128, 217)",
    "rgb(91, 184, 175)",
];
var usePrepareData = function (_a) {
    var _data = _a._data, labelPath = _a.labelPath, valuePath = _a.valuePath, plotDataPoint = _a.plotDataPoint;
    return (0, react_1.useMemo)(function () {
        var finalData = __spreadArray([], _data, true);
        var totalCount = (0, getTotalCount_1.getTotalCount)({ data: finalData, countPath: valuePath });
        finalData = finalData.map(function (d) { return ({
            labels: __assign(__assign({}, (plotDataPoint === "percentage"
                ? { percentage: (0, _EXPORTS_1.getPercentage)((0, _EXPORTS_1.getVal)(d, valuePath), totalCount) }
                : {})), { count: (0, _EXPORTS_1.getVal)(d, valuePath), name: (0, _EXPORTS_1.getVal)(d, labelPath) }),
        }); });
        // Sort by value
        finalData.sort(function (a, b) { return b.labels.count - a.labels.count; });
        return finalData;
    }, [_data, labelPath, valuePath, plotDataPoint]);
};
var CustomLabel = function (_a) {
    var viewBox = _a.viewBox, value = _a.value;
    var cx = viewBox.cx, cy = viewBox.cy;
    return (react_1.default.createElement("text", { x: cx, y: cy, textAnchor: "middle", dominantBaseline: "central", className: "text-sm font-medium" }, value));
};
var renderActiveShape = function (props) {
    var cx = props.cx, cy = props.cy, innerRadius = props.innerRadius, outerRadius = props.outerRadius, startAngle = props.startAngle, endAngle = props.endAngle, fill = props.fill, payload = props.payload;
    return (react_1.default.createElement("g", null,
        react_1.default.createElement(recharts_1.Sector, { cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius + 8, startAngle: startAngle, endAngle: endAngle, fill: fill }),
        react_1.default.createElement(recharts_1.Sector, { cx: cx, cy: cy, startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius - 4, outerRadius: innerRadius - 2, fill: fill })));
};
var PieChart = function (_a) {
    var _data = _a.data, valuePath = _a.valuePath, _b = _a.labelPath, labelPath = _b === void 0 ? "name" : _b, onClick = _a.onClick, _c = _a.colors, colors = _c === void 0 ? chartColors : _c, _d = _a.colorIdx, colorIdx = _d === void 0 ? 0 : _d, _e = _a.plotDataPoint, plotDataPoint = _e === void 0 ? "percentage" : _e, innerLabel = _a.innerLabel;
    var data = usePrepareData({
        _data: _data,
        labelPath: labelPath,
        valuePath: valuePath,
        plotDataPoint: plotDataPoint,
    });
    var _f = (0, react_1.useState)(), activeIndex = _f[0], setActiveIndex = _f[1];
    var onPieEnter = function (_, index) {
        setActiveIndex(index);
    };
    var onPieLeave = function () {
        setActiveIndex(undefined);
    };
    var onPieClick = function (_, index) {
        if (onClick) {
            onClick(data[index].labels.name);
        }
    };
    return (react_1.default.createElement("div", { className: "w-full", style: { height: "300px" } },
        react_1.default.createElement(recharts_1.ResponsiveContainer, { width: "100%", height: "100%" },
            react_1.default.createElement(recharts_1.PieChart, null,
                react_1.default.createElement(recharts_1.Pie, { data: data, dataKey: "labels.count", nameKey: "labels.name", cx: "50%", cy: "50%", innerRadius: 60, outerRadius: 80, paddingAngle: 1, activeIndex: activeIndex, activeShape: renderActiveShape, onMouseEnter: onPieEnter, onMouseLeave: onPieLeave, onClick: onClick ? onPieClick : undefined, style: onClick ? { cursor: "pointer" } : {} }, data.map(function (entry, index) { return (react_1.default.createElement(recharts_1.Cell, { key: "cell-".concat(index), fill: colors[(index + colorIdx) % colors.length], opacity: activeIndex !== undefined && activeIndex !== index ? 0.4 : 1 })); }))))));
};
exports.PieChart = PieChart;
